const addLastBullet = (originalString, searchString) => {
  const replacementString = `${searchString} last-bullet`;

  // Encuentra la última aparición de 'searchString'
  const lastIndex = originalString.lastIndexOf(searchString);

  if (lastIndex !== -1) {
    // Divide el string en dos partes: antes y después de la última aparición
    const beforeLastBullet = originalString.slice(0, lastIndex);
    const afterLastBullet = originalString.slice(lastIndex);

    // Crea el nuevo string con la modificación
    return beforeLastBullet + afterLastBullet.replace(searchString, replacementString);
  } else {
    return originalString; // Si no se encuentra 'searchString', retorna el original
  }
};

export default addLastBullet;
